<template>
<div>
    <ValidationObserver ref="observer" v-slot="{ passes }">
        <div class="nj-card">
            <h1 class="subtitle">Ordenes de Compra o Servicio</h1>
            <hr />
            <orden-header :orden="orden" @seleccionarPedido="seleccionarPedido($event)"></orden-header>
            <br>
            <orden-detail :orden="orden" :passes="passes"></orden-detail>
        </div>
    </ValidationObserver>
</div>
</template>
<script>
import { ValidationObserver } from "vee-validate"
import { TipoImpuestoEnum } from "../constants"
import { OrdenCompraEvent, OrdenCompraEventTypes } from "../util/events"
import OrdenDetail from "./OrdenDetail"
import OrdenHeader from "./OrdenHeader"

export default {
    name: "OrdenNew",
    components: {
        OrdenDetail,
        OrdenHeader,
        ValidationObserver
    },
    data() {
        return {
            orden: {
                orden_items: [],
                // * colocando los impuestos por defecto:
                orden_impuestos: [
                    TipoImpuestoEnum.IGV
                ],
                descuento: 0,
                tipo_descuento: 1,
                tipo_orden: 1,
                lugar_entrega: "AV. MANUEL OLGUÍN 211, SANTIAGO DE SURCO",
                monto_con_impuesto: 0,
                monto_son_impuesto: 0,
                es_importacion: false,
                centro_costo: {
                    id_centro_costo: null
                },
                proveedor: {
                    id_proveedor: null
                },
                metodo_pago: {
                    id_metodo: null
                },
                tipo_documento: {
                    id_tipo_documento: null
                },
                fecha_pago: null,
                carta_credito: "",
                condicion_comercial: { id_condicion: null },
                gerencia: { id_usuario: null },
                administrador: { id_usuario: null },
                contabilidad: { id_usuario: null },
                pais: { id_pais: null },
                moneda: { id_moneda: null },
                referencia: "",
                referencia_detalle: "",
                observacion: "",
                is_new: true,
                ord_porcentaje_adelanto: null,
            },
        }
    },
    methods: {
        seleccionarPedido(pedido) {
            if (pedido != undefined && pedido != null) {
                OrdenCompraEvent.$emit(OrdenCompraEventTypes.cargarItemsDePedido, pedido.pei_id)
            }
        }
    },
}
</script>

<style scoped></style>
